import React from "react";
import {
  Table,
  Stack,
  Form,
  Dropdown,
  Card,
  Row,
  Col,
  Button,
  Container,
  Modal,
  Pagination,
  ButtonGroup
} from "react-bootstrap";
import "../css/ProductTable.css";
import "../css/ProductImage.css";
import "./sales.css";
import {downloadProductqrcode, deleteProduct, deleteProductBatch, getProductById, getProducts, getShareCount, increaseShareCount, increaseViewCount, updateStatus, updateStatusBatch } from "../services/ProductsService";
import { useNavigate } from "react-router-dom";
import ModalComponent from "../components/Modal/Modal";
import { EditStateContext, ModalBody, ModalFooter } from "../components/ProductDetailsHeader";
import Swal from 'sweetalert2';
import ReactPaginate from 'react-paginate';

export const withNavigation = (Component) => {
  return (props) => <Component {...props} navigate={useNavigate()} />;
};

class SalesProductTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      filteredData: [],
      productData: [],
      sortColumn: "status",
      sortDirection: "asc",
      showDeleteModal: false,
      showShareModal: false,
      showEditModal: false,
      count: null,
      currentPage: 1, // Current page number
      itemsPerPage: 10,// Number of items per page
      selectAllChecked: false,
      isUpdated: false,
      shareLink: "",
      statusUpdates: {},
    };
  }

  componentDidMount() {
    this.fetchProducts();
    this.filterData();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.searchQuery !== this.props.searchQuery ||
      this.state.isUpdated !== prevState.isUpdated ||
      prevState.productData !== this.state.productData
    ) {
      this.filterData();
    }
    if (prevState.isUpdated !== this.state.isUpdated) {
      this.state.productData = [];
    }
  }

  // Get all products
  async fetchProducts() {
    debugger;
    try {
      const products = await getProducts();

      this.setState(
        {
          data: products,
          productData: [],
        },
        () => {
          this.filterData();
        }
      );
    } catch (err) {
      console.log(err);
    }
  }
  async downloadQRCode(id) {
    const organizationIdentifier = this.getCookie('organizationIdentifier');
  debugger;
    try {
      const product = await getProductById(id);
      const url = window.location.origin;
      const linkInput = product?.shareLink;
    const linkWithoutPrefix = linkInput.replace(/.*\/v1\/products\//, '');
    const newLink = `${url}/products/${organizationIdentifier}/${linkWithoutPrefix}`;
      const newLink1 = "https://showcasedemo.trezi.com/products/public/TZNSOSO1121211692708420773";
  
      const response = await downloadProductqrcode(newLink);
  
      if (response) {

        let fileName = 'qrcode.png'; // Default filename
        
        const blobUrl ="data:image/png;base64,"+response.data.qrCodeBytes;
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = blobUrl;
        a.download = fileName;
        
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(blobUrl);
        document.body.removeChild(a);
        Swal.fire({
          title: 'Success!',
          text: 'Product downloaded successfully.',
          icon: 'success',
          timer: 2000, // Optional: Automatically close after 2 seconds
        });
      } else {
        Swal.fire({
          title: 'Error!',
          text: 'Failed to download the product.',
          icon: 'error',
        });
      }
    } catch (err) {
      console.error(err);
      Swal.fire({
        title: 'Error!',
        text: 'Failed to download the product.',
        icon: 'error',
      });
    }
  }
  // Filtered products while searching
  filterData = () => {
    debugger
    const { searchQuery } = this.props;
    const { data, currentPage, itemsPerPage } = this.state;
    let filteredData = data;
    if (!searchQuery) {
      this.setState({ filteredData: data });
      return;
    } else {
      const filteredData = data.filter(
        (item) =>
          item.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
          item.productId
            .toString()
            .toLowerCase()
            .includes(searchQuery.toLowerCase().trim())
      );
      // Calculate indexes for pagination
      const indexOfLastItem = currentPage * itemsPerPage;
      const indexOfFirstItem = indexOfLastItem - itemsPerPage;

      // Update filteredData based on current page and itemsPerPage
      const currentDataPagination = filteredData.slice(indexOfFirstItem, indexOfLastItem);
      this.setState({ filteredData: currentDataPagination });
    }
  };

  handlePaginationClick = (pageNumber) => {
    this.setState({ currentPage: pageNumber });
  };
  handleSelectAllCheck = (e) => {
    const checked = e.target.checked;
    this.setState((prevState) => {
      const updatedData = prevState.filteredData.map((item) => ({
        ...item,
        selected: checked,
      }));

      const count = prevState.filteredData.length;
      const show = checked;
      const selectAllChecked = checked;

      const productData = [...prevState.productData]; // Preserve existing productData

      if (checked) {
        const selectedIds = updatedData.map((item) => item.productId);

        Promise.all(selectedIds.map(async (id) => await getProductById(id)))
          .then((selectedProductData) => {
            selectedProductData = selectedProductData.filter(Boolean); // Remove null or undefined values

            const updatedProductData = productData.concat(selectedProductData); // Merge existing and new productData

            const selectedIds = updatedData.map((item) => item.productId);

            this.setState({
              data: updatedData,
              filteredData: updatedData,
              count: count,
              show: show,
              selectAllChecked: selectAllChecked,
              productId: selectedIds,
              productIds: selectedIds,
              productData: updatedProductData, // Set the updated productData
            });
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        const deselectedIds = updatedData
          .filter((item) => !item.selected)
          .map((item) => item.productId);

        const updatedProductData = productData.filter(
          (item) => !deselectedIds.includes(item.productId)
        );

        const selectedIds = updatedData.map((item) => item.productId);

        this.setState({
          data: updatedData,
          filteredData: updatedData,
          count: count,
          show: show,
          selectAllChecked: selectAllChecked,
          productId: selectedIds,
          productIds: selectedIds,
          productData: updatedProductData, // Set the updated productData
        });
      }
    });
  };

  // select particular checkbox
  handleCheckboxChange = (id) => async (e) => {
    debugger;
    if (id) {
      try {
        const productData = await getProductById(id);
        // const url = window.location.origin;
        // const linkInput = productData?.shareLink;
        // const newLink = linkInput?.replace(/.*\/v1/, `${url}`);
        const organizationIdentifier = this.getCookie('organizationIdentifier');
        const url = window.location.origin;
      const linkInput = productData?.shareLink;
    const linkWithoutPrefix = linkInput.replace(/.*\/v1\/products\//, '');
    const newLink = `${url}/products/${organizationIdentifier}/${linkWithoutPrefix}`;
        this.setState((prevState) => {
          return {
            productData: [...prevState.productData, productData],
            shareLink: newLink,
          };
        });
      } catch (err) {
        console.log(err);
      }
    } else {
      this.setState((prevState) => {
        const updatedProductData = prevState.productData.filter(
          (item) => item.productId !== id
        );
        return {
          productData: updatedProductData,
        };
      });
    }
  };

  // Sort data according to selected column
  handleSort = (column) => {
    const { filteredData, sortColumn, sortDirection } = this.state;

    // Toggle sort direction if the same column is clicked
    const newSortDirection =
      column === sortColumn && sortDirection === "asc" ? "desc" : "asc";

    const sortedData = filteredData.slice().sort((a, b) => {
      if (column === "created on") {
        if (a.createdAt < b.createdAt)
          return newSortDirection === "asc" ? -1 : 1;
        if (a.createdAt > b.createdAt)
          return newSortDirection === "asc" ? 1 : -1;
      } else if (column === "status") {
        const statusA = a.status.toLowerCase();
        const statusB = b.status.toLowerCase();

        if (statusA < statusB) return newSortDirection === "asc" ? -1 : 1;
        if (statusA > statusB) return newSortDirection === "asc" ? 1 : -1;
      } else {
        if (a.updatedAt < b.updatedAt)
          return newSortDirection === "asc" ? -1 : 1;
        if (a.updatedAt > b.updatedAt)
          return newSortDirection === "asc" ? 1 : -1;
      }
      return 0;
    });

    this.setState({
      data: sortedData,
      filteredData: sortedData,
      sortColumn: column,
      sortDirection: newSortDirection,
    });
  };
  getCookie = (name) => {
    const cookieString = document.cookie;
    const cookies = cookieString.split(';');
   for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();
      if (cookie.startsWith(name + '=')) {
        return cookie.substring(name.length + 1);
      }
    }
    return null;
  };
  handleItemClick = (productId, code, label) => {
    const organizationIdentifier = this.getCookie('organizationIdentifier');
    increaseViewCount(productId, code, label);
    this.props.navigate(`/sales-products/${organizationIdentifier}/${productId}`);
  };

  // Status change
  handleStatusChange = async (id, selectedStatus, productIds, status) => {
    if (id !== null && selectedStatus !== null) {
      const { code, label } = selectedStatus; // Destructure the code and label from the selectedStatus object
      await updateStatus(id, selectedStatus).then((response) => {
        if (response.status === 417) {
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: "Can't update status",
          });
          return;
        }
        else if (response.status === 200) {
          this.setState(
            (prevState) => {
              const updatedData = prevState.data.map((item) =>
                item.productId === id
                  ? { ...item, status: { code, label } }
                  : item
              );
              const updatedFilteredData = prevState.filteredData.map((item) =>
                item.productId === id
                  ? { ...item, status: { code, label } }
                  : item
              );
              const updatedProductData = prevState.productData.map(
                (item, index) =>
                  index === 0 ? { ...item, status: { code, label } } : item
              );
              return {
                data: updatedData,
                filteredData: updatedFilteredData,
                productData: updatedProductData,
              };
            },
            () => {
              this.fetchProducts();
              this.filterData();
              this.setState({ show: false, selectAllChecked: false });
            }
          );
        }
      });
    } else if (productIds !== null && status !== null) {
      // const { code, label } = status; // Destructure the code and label from the status object
      const statusBatch = productIds?.map((productId, index) => {
        return { productId, status };
      });

      await updateStatusBatch(statusBatch).then((response) => {
        debugger;
        if (response === 400) {
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: "One or more products status could not be updated...",
          });
          return;
        }
        else if (response === 200) {
          debugger;
          // this.filterData();
          // this.fetchProducts();
          this.setState(
            (prevState) => {
              const updatedData = prevState.data.map((item) => {
                const updatedStatus = statusBatch.find((batchItem) => batchItem.productId === item.productId);
                if (updatedStatus) {
                  return { ...item, status: updatedStatus.status };
                }
                return item;
              });
      
              const updatedFilteredData = prevState.filteredData.map((item) => {
                const updatedStatus = statusBatch.find((batchItem) => batchItem.productId === item.productId);
                if (updatedStatus) {
                  return { ...item, status: updatedStatus.status };
                }
                return item;
              });
      
              const updatedProductData = prevState.productData.map((item) => {
                const updatedStatus = statusBatch.find((batchItem) => batchItem.productId === item.productId);
                if (updatedStatus) {
                  return { ...item, status: updatedStatus.status };
                }
                return item;
              });
      
              return {
                data: updatedData,
                filteredData: updatedFilteredData,
                productData: updatedProductData,
              };
            },
            () => {
              this.fetchProducts();
              this.filterData();
              this.setState({ show: false, selectAllChecked: false });
              this.setState({ filteredData: [] });
            }
          );
        }
      });
    }
  };



  // Deleting a product or batch of products
  handleDeleteProduct = async (productIds) => {
    debugger;
    if (productIds.length > 1) {
      try {
        const response = await deleteProductBatch(productIds);
        if (response.status === 200) {
          this.fetchProducts();
          this.setState({ filteredData: [] });
          this.closeDeleteModal();
          Swal.fire('Product Deleted', 'Selected products have been deleted.', 'success');
        } else {
          throw new Error("Failed to delete product");
        }
      } catch (err) {
        console.log(err);
        Swal.fire('Error', 'Failed to delete products.', 'error');
      }
    } else if (productIds.length === 1) {
      try {
        const response = await deleteProduct(productIds);
        if (response === "Product deleted.") {
          this.fetchProducts();
          this.setState({ filteredData: [] });
          this.closeDeleteModal();
          Swal.fire('Product Deleted', 'The product has been deleted.', 'success');
        } else {
          throw new Error("Failed to delete product");
        }
      } catch (err) {
        console.log(err);
        Swal.fire('Error', 'Failed to delete the product.', 'error');
      }
    }
  };

  // For sharing link of product by copying.
  copyLink = async (productId, code, label) => {
    try {
      await increaseShareCount(productId, code, label).then(() =>
        getShareCount(productId, code, label).then((response) => {
          this.setState({ shareCount: response });
          this.props.setShareCount(this.state.shareCount);
        })
      );

      const linkInput = document.getElementById("link-input");
      console.log("Link input", linkInput)
      linkInput?.select();
      document.execCommand("copy");
    } catch (error) {
      console.log(error);
    }
  };

  handlePageChange = (pageNumber) => {
    this.setState({ currentPage: pageNumber }, () => {
      this.filterData(); // Update filteredData based on the new page
    });
  };

  openDeleteModal = () => {
    debugger;
    this.setState({ showDeleteModal: true });
  };

  closeDeleteModal = () => {
    this.setState({ showDeleteModal: false });
  };

  openShareModal= async (productId) => {
    debugger;
    try {
      const productData = await getProductById(productId);
      // const url = window.location.origin;
      // const linkInput = productData?.shareLink;
      // const newLink = linkInput?.replace(/.*\/v1/, `${url}`);
      const organizationIdentifier = this.getCookie('organizationIdentifier');
      const url = window.location.origin;
    const linkInput = productData?.shareLink;
  const linkWithoutPrefix = linkInput.replace(/.*\/v1\/products\//, '');
  const newLink = `${url}/products/${organizationIdentifier}/${linkWithoutPrefix}`;
      this.setState((prevState) => {
        return {
          productData: [...prevState.productData, productData],
          shareLink: newLink,
        };
      });
    } catch (err) {
      console.log(err);
    }
    this.setState({ showShareModal: true });
  };

  closeShareModal = () => {
    this.setState({ showShareModal: false });
  };

  openEditModal = () => {
    debugger;
    this.setState((prevState) => ({ ...prevState, showEditModal: !prevState.showEditModal }));
  };

  closeEditModal = () => {
    this.setState({ showEditModal: false });
  };

  productListUpdate = () => {
    this.setState(prevState => ({ ...prevState, isUpdated: !prevState.isUpdated }));
    this.fetchProducts();
    this.setState({ show: false });
  };

  isProductUpdate = () => {
    this.setState(prevState => ({ ...prevState, isUpdated: !prevState.isUpdated }));
  };

  render() {
    const {
      sortColumn,
      selectAllChecked,
      productData,
      sortDirection,
      showDeleteModal,
      showShareModal,
      count,
      show,
      productId,
      productIds,
      filteredData,
      currentPage,
      itemsPerPage,
      shareLink
    } = this.state;
    const { view } = this.props;
    const getRole = localStorage.getItem('role');

    const TimestampInfo = (time) => {
      if (time === null || time === 0) {
        return "-";
      }
      const timestamp = time;
      const datetimeObj = new Date(timestamp);

      const month = datetimeObj.toLocaleString("default", { month: "short" });
      const date = datetimeObj.getDate();
      const day = datetimeObj.toLocaleString("en-US", { weekday: "long" });
      const year = datetimeObj.getFullYear();

      return (
        <div>
          <span className="tz-month custom-font-12">
            {month} {date}, {year}
          </span>{" "}
          <br />
          <span className="tz-day custom-font-12">{day}</span>
        </div>
      );
    };

    // Calculate the indexes of the items to display on the current page
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;

    const pageNumbers = [];
    for (let i = 1; i <= Math.ceil(filteredData.length / itemsPerPage); i++) {
      debugger;
      pageNumbers.push(i);
    }

    // Calculate the index of the last and first attribute based on currentPage
    const indexOfLastAttribute = currentPage * itemsPerPage;
    const indexOfFirstAttribute = indexOfLastAttribute - itemsPerPage;
    const currentDataPaginition = filteredData.slice(indexOfFirstAttribute, indexOfLastAttribute);
    return (
      <Stack className="table-product-container">
        {show && (
          <div
            className="select-checkbox"
            style={{
              display: "flex",
              justifyContent: "space-between",
              maxWidth: "100%",
              border: "1px solid #2B91FF",
              borderRadius: "4px",
              height: "50px",
              padding: "12px 12px",
              marginBottom: "18px",
              backgroundColor: "#E5F0FB",
            }}
          >
            <div
              style={{
                color: "#6A6D74",
                fontWeight: "400",
                fontStyle: "normal",
                fontSize: "14px",
              }}
            >
              {count} {count > 1 ? "Products" : "Product"} in this page{" "}
              {count > 1 ? "are" : "is"} selected
            </div>
          
          </div>
        )}
        <Table hover borderless className="product-table">
          {/* Change according to selected view */}
          {view === "List" ? (
            <thead className="list-view-table-head">
              <tr>
                <th className="sales-second-product-column-th">
                  Title & Tzn Number
                </th>
               
                {/* <th className="sales-fifth-product-column-th">
                  <div
                    className="d-flex sort-column align-items-center"
                    onClick={() => this.handleSort("modified on")}
                  >
                    <span className="">Share</span>
                    <div className="sort-icons">
                      <button
                        className={`sort-button ${sortColumn === "modified on" &&
                          sortDirection === "asc" &&
                          "active"
                          }`}
                      >
                        <span className="bi bi-caret-up-fill"></span>
                        <span className="bi bi-caret-down-fill"></span>
                      </button>
                    </div>
                  </div>
                </th> */}
              </tr>
            </thead>
          ) : (
            <thead className="grid-view-table-head"></thead>
          )}
          {view === "List" ? (
            <tbody className="table-body">
              {currentDataPaginition?.map((item, index) => (
                <tr key={index} className="tz-table-body-row">
                  <td
                    className="sales-second-product-column"
                    onClick={() =>
                      this.handleItemClick(
                        item.productId,
                        item.status,
                      )
                    }
                  >
                    <div className="name-container">
                      <img
                        src={item.thumbnail.fileUrl}
                        alt={item.thumbnail.fileName}
                        className="avatar"
                      />
                      <span>
                        <div className="product-title custom-font-12">
                          {item?.title}
                        </div>
                        <div className="product-serial custom-font-12">
                          {item.productId}
                        </div>
                      </span>
                    </div>
                  </td>
                 
                  <td className="sales-fifth-product-column">
                  <Button
                  className="custom-button"
                    style={{ cursor: "pointer" }}
                    // onClick={this.openShareModal}
                    onClick={() =>
                      this.openShareModal(
                        item.productId
                      )
                    
                    }
                  >
                    <i
                      className="bi bi-share-fill"
                      style={{ color: "#0070DC" }}
                    ></i>
                    <span
                      style={{
                        marginLeft: "8px",
                      }}
                      className="custom-font-12"
                    >
                      Share
                    </span>
                  </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          ) : (
            <tbody className="grid-view-table-body">
              <Container fluid>
                <Row sm={2} md={2} lg={3} xl={3} className="p-0">
                  {currentDataPaginition ?.map((item) => (
                    <Col key={item.productId} className="mb-4">
                      <Card className="grid-view-product-card">
                        <Card.Body className="d-flex flex-column justify-content-between">
                          <div className="d-flex justify-content-between align-items-center">               
                          </div>
                          <div
                            className="product-grid-view-image-container mt-3"
                            onClick={() => this.handleItemClick(item.productId)}
                          >
                            <Card.Img
                              variant="top"
                              src={item.thumbnail.fileUrl}
                              alt={item.thumbnail.fileName}
                            />
                          </div>
                          <div className="mt-2 align-center">
                            <span
                              className="product-title custom-font-14"
                              onClick={() =>
                                this.handleItemClick(item.productId)
                              }
                            >
                              {item.title}
                            </span>
                            <br />
                            <span
                              className="product-serial custom-font-12"
                              onClick={() =>
                                this.handleItemClick(item.productId)
                              }
                            >
                              {item.productId}
                            </span>
                          </div>
                          <Button 
                        className="custom-button"
                            onClick={() =>
                      this.openShareModal(
                        item.productId
                      )
                             }>
                          <div
                    style={{ cursor: "pointer" }}
                    // onClick={this.openShareModal}
                    onClick={() =>
                      this.openShareModal(
                        item.productId
                      )
                    
                    }
                  >
                    <i
                      className="bi bi-share-fill"
                      style={{ color: "#0070DC" }}
                    ></i>
                    <span
                      style={{
                        marginLeft: "8px",
                      }}
                      className="custom-font-12"
                    >
                      Share
                    </span>
                  </div>
                          </Button>
                        </Card.Body>
                      </Card>
                    </Col>
                  ))}
                </Row>
              </Container>
            </tbody>
          )}
        </Table>
 {/* Share Modal */}
 <Modal
                    show={showShareModal}
                    onHide={this.closeShareModal}
                    className="tz-modal"
                  >
                    <Modal.Header closeButton>
                      <Modal.Title
                        style={{ fontSize: "14px", color: "#000000" }}
                      >
                        To share, copy the link below
                      </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <ButtonGroup>
                        <Form.Control
                          id="link-input"
                          type="text"
                          value={shareLink}
                          readOnly
                          className="mr-2"
                        />
                            <div className="d-flex align-items-center">
                            <Button
                          onClick={() =>
                            this.copyLink(
                              productData[0].productId,
                              productData[0].status.code,
                              productData[0].status.label
                            )
                          }
                          className="mr-2"
                        >
                             <i className="bi bi-files"></i> Copy
                        </Button>
                        <Button onClick={() => this.downloadQRCode(productData[0].productId,)}>  <i className="bi bi-download"></i> Download QR</Button>
                            </div>
                       
                      </ButtonGroup>
                    </Modal.Body>
                  </Modal>
        <div className="pagination">
          <ReactPaginate
            pageCount={Math.ceil(filteredData.length / itemsPerPage)}
            pageRangeDisplayed={5}
            marginPagesDisplayed={1}
            onPageChange={(selectedPage) => this.handlePaginationClick(selectedPage.selected + 1)}
            containerClassName="pagination"
            activeClassName="pagination-item-active"
          />
        </div>
      </Stack>
    );
  }
}
export default withNavigation(SalesProductTable);